// Typelizer digest ec8bb257d85ade10b29db8b3bc6353d5
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** POST /c/:company_id/ledger/review_queue/verification */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/ledger/review_queue/verification', {}, options),
    method: 'post',
  }),
}
